<template>
  <div class="integrated-export-container">
    <el-card>
      <div slot="header" class="clearfix">
        <span>整合表校验与下载</span>
      </div>

      <!-- 查询表单 -->
      <el-form 
        :model="exportForm" 
        :rules="rules"
        ref="exportForm"
        label-width="120px"
        class="export-form"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="月份" prop="month">
              <el-input 
                v-model="exportForm.month" 
                placeholder="请输入月份(格式: 202501)"
                clearable
              >
                <i slot="prefix" class="el-input__icon el-icon-date"></i>
              </el-input>
            </el-form-item>
          </el-col>
          
          <el-col :span="12">
            <el-form-item label="销售代表" prop="sales">
              <el-input 
                v-model="exportForm.sales" 
                placeholder="请输入销售代表"
                clearable
              >
                <i slot="prefix" class="el-input__icon el-icon-user"></i>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="代理商ID">
              <el-input 
                v-model="exportForm.agentid" 
                placeholder="请输入代理商ID(可选)"
                clearable
              >
                <i slot="prefix" class="el-input__icon el-icon-office-building"></i>
              </el-input>
            </el-form-item>
          </el-col>
          
          <el-col :span="12">
            <el-form-item label="Payer ID">
              <el-input 
                v-model="exportForm.payer" 
                placeholder="请输入Payer ID(可选)"
                clearable
              >
                <i slot="prefix" class="el-input__icon el-icon-wallet"></i>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="对账单版本">
              <el-select 
                v-model="exportForm.detailBillType" 
                placeholder="请选择对账单版本"
                clearable
              >
                <el-option label="伙伴对账单" value="agent"></el-option>
                <el-option label="客户对账单" value="client"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          
          <el-col :span="12">
            <el-form-item label="数据过滤">
              <el-checkbox v-model="exportForm.filterZeroData">
                过滤全0数据
              </el-checkbox>
              <div style="font-size: 12px; color: #909399; margin-top: 4px;">
                勾选后将过滤掉Charge、Credits、Tax、Total等核心字段全为0的数据
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item label="导出列">
              <el-checkbox-group v-model="selectedColumns">
                <el-checkbox label="payer_id">Payer ID</el-checkbox>
                <el-checkbox label="link_id">Link ID</el-checkbox>
                <el-checkbox label="customer_name">客户名称</el-checkbox>
                <el-checkbox label="charges">Charges</el-checkbox>
                <el-checkbox label="credits">Credits</el-checkbox>
                <el-checkbox label="savings_plan">Savings Plan</el-checkbox>
                <el-checkbox label="bundle">Bundle Discount</el-checkbox>
                <el-checkbox label="distribution">Distribution</el-checkbox>
                <el-checkbox label="tax">Tax</el-checkbox>
                <el-checkbox label="total">Total</el-checkbox>
                <el-checkbox label="vat">VAT%</el-checkbox>
              </el-checkbox-group>
              <div style="margin-top: 10px;">
                <el-button type="text" size="small" @click="selectAllColumns">全选</el-button>
                <el-button type="text" size="small" @click="clearAllColumns">清空</el-button>
                <el-button type="text" size="small" @click="selectDefaultColumns">默认</el-button>
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button 
            type="primary" 
            @click="validateAndExport"
            :loading="downloading"
            icon="el-icon-download"
          >
            校验并下载整合表
          </el-button>
          <el-button @click="resetForm">重置</el-button>
          <el-button 
            type="info" 
            @click="showHistory"
            icon="el-icon-time"
          >
            下载历史
          </el-button>
        </el-form-item>
      </el-form>

      <!-- 校验结果提示 -->
      <el-alert
        v-if="validationMessage"
        :title="validationMessage"
        :type="validationStatus"
        :closable="false"
        show-icon
        style="margin-top: 20px;"
      >
      </el-alert>

      <!-- 下载历史记录 -->
      <div v-if="showHistoryTable" class="history-section">
        <el-divider content-position="left">下载历史记录</el-divider>
        <el-table 
          :data="downloadHistory" 
          style="width: 100%"
          size="small"
        >
          <el-table-column prop="month" label="月份" width="120" />
          <el-table-column prop="sales" label="销售代表" width="120" />
          <el-table-column prop="agentid" label="代理商ID" width="150" />
          <el-table-column prop="downloadTime" label="下载时间" width="180">
            <template slot-scope="scope">
              {{ formatDate(scope.row.downloadTime) }}
            </template>
          </el-table-column>
          <el-table-column prop="fileName" label="文件名" min-width="200" />
          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-button 
                type="text" 
                size="small"
                @click="redownload(scope.row)"
              >
                重新下载
              </el-button>
              <el-button 
                type="text" 
                size="small"
                @click="deleteHistory(scope.$index)"
              >
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'IntegratedExport',
  data() {
    return {
      exportForm: {
        month: '',
        sales: '',
        agentid: '',
        payer: '',
        detailBillType: '',
        filterZeroData: false  // 新增：是否过滤全0数据
      },
      rules: {
        month: [
          { required: true, message: '请输入月份(格式: 202501)', trigger: 'blur' },
          { pattern: /^\d{6}$/, message: '月份格式不正确，应为6位数字(如: 202501)', trigger: 'blur' }
        ],
        sales: [
          { required: true, message: '请输入销售代表', trigger: 'blur' }
        ]
      },
      selectedColumns: [
        'payer_id', 'link_id', 'customer_name', 
        'charges', 'credits', 'tax', 'total'
      ],
      downloading: false,
      validationMessage: '',
      validationStatus: 'info',
      showHistoryTable: false,
      downloadHistory: []
    };
  },
  mounted() {
    this.loadDownloadHistory();
  },
  methods: {
    validateAndExport() {
      this.$refs.exportForm.validate((valid) => {
        if (valid) {
          this.downloadIntegratedExcel();
        } else {
          this.$message.warning('请填写完整的查询条件');
          return false;
        }
      });
    },

    async downloadIntegratedExcel() {
      this.downloading = true;
      this.validationMessage = '正在校验数据...';
      this.validationStatus = 'info';

      try {
        const params = {
          month: this.exportForm.month,
          sales: this.exportForm.sales,
          columns: this.selectedColumns.join(',')
        };
        
        // 添加可选参数
        if (this.exportForm.agentid) {
          params.agentid = this.exportForm.agentid;
        }
        if (this.exportForm.payer) {
          params.payer = this.exportForm.payer;
        }
        if (this.exportForm.detailBillType) {
          params.detail_bill_type = this.exportForm.detailBillType;
        }
        if (this.exportForm.filterZeroData) {
          params.filter_zero = '1';  // 传递过滤全0数据的参数
        }
        
        const response = await this.$http.get('/bill/invoice/export/', {
          params: params,
          responseType: 'blob'
        });

        // 检查响应类型
        if (response.data.type === 'application/json') {
          // 如果返回的是JSON错误
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const errorData = JSON.parse(reader.result);
              this.validationMessage = errorData.message || '导出失败';
              this.validationStatus = 'error';
              this.$message.error(this.validationMessage);
            } catch {
              this.validationMessage = '导出失败';
              this.validationStatus = 'error';
              this.$message.error('导出失败');
            }
          };
          reader.readAsText(response.data);
          return;
        }

        // 成功获取文件
        this.validationMessage = '数据校验通过，正在下载...';
        this.validationStatus = 'success';

        // 从响应头获取文件名
        const contentDisposition = response.headers['content-disposition'];
        const contentType = response.headers['content-type'];
        
        let fileName = `export_${this.exportForm.month}_${this.exportForm.sales}.xlsx`;
        
        // 根据Content-Type判断文件类型
        if (contentType) {
          if (contentType.includes('zip')) {
            fileName = `export_${this.exportForm.month}_${this.exportForm.sales}.zip`;
          } else if (contentType.includes('spreadsheet') || contentType.includes('excel')) {
            fileName = `export_${this.exportForm.month}_${this.exportForm.sales}.xlsx`;
          }
        }
        
        // 如果响应头有文件名，使用响应头的文件名
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename\*=UTF-8''([^;\n]+)|filename[^;=\n]*=((['"]).*?\3|[^;\n]*)/);
          if (fileNameMatch) {
            // 优先使用RFC 5987编码的文件名
            if (fileNameMatch[1]) {
              fileName = decodeURIComponent(fileNameMatch[1]);
            } else if (fileNameMatch[2]) {
              fileName = decodeURIComponent(fileNameMatch[2].replace(/['"]/g, ''));
            }
          }
        }

        // 创建下载链接
        const blob = new Blob([response.data], { type: contentType || 'application/octet-stream' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        
        // 清理
        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }, 100);

        this.$message.success('导出成功');
        
        // 保存下载历史
        this.saveDownloadHistory(fileName);

        // 3秒后清除提示
        setTimeout(() => {
          this.validationMessage = '';
        }, 3000);

      } catch (error) {
        console.error('导出错误:', error);
        
        if (error.response && error.response.data) {
          // 处理blob错误响应
          if (error.response.data instanceof Blob) {
            const reader = new FileReader();
            reader.onload = () => {
              try {
                const errorData = JSON.parse(reader.result);
                this.validationMessage = errorData.message || '导出失败';
                this.validationStatus = 'error';
                this.$message.error(this.validationMessage);
              } catch {
                this.validationMessage = '导出失败';
                this.validationStatus = 'error';
                this.$message.error('导出失败');
              }
            };
            reader.readAsText(error.response.data);
          } else {
            this.validationMessage = error.response.data.message || '导出失败';
            this.validationStatus = 'error';
            this.$message.error(this.validationMessage);
          }
        } else {
          this.validationMessage = '网络错误，请稍后重试';
          this.validationStatus = 'error';
          this.$message.error('导出失败: ' + error.message);
        }
      } finally {
        this.downloading = false;
      }
    },

    resetForm() {
      this.$refs.exportForm.resetFields();
      this.validationMessage = '';
    },

    showHistory() {
      this.showHistoryTable = !this.showHistoryTable;
      if (this.showHistoryTable) {
        this.loadDownloadHistory();
      }
    },

    loadDownloadHistory() {
      // 从localStorage加载下载历史
      const history = localStorage.getItem('downloadHistory');
      if (history) {
        try {
          this.downloadHistory = JSON.parse(history);
        } catch (e) {
          this.downloadHistory = [];
        }
      }
    },

    selectAllColumns() {
      this.selectedColumns = [
        'payer_id', 'link_id', 'customer_name', 'charges', 
        'credits', 'savings_plan', 'bundle', 'distribution', 
        'tax', 'total', 'vat'
      ];
    },
    
    clearAllColumns() {
      this.selectedColumns = [];
    },
    
    selectDefaultColumns() {
      this.selectedColumns = [
        'payer_id', 'link_id', 'customer_name', 
        'charges', 'credits', 'tax', 'total'
      ];
    },

    saveDownloadHistory(fileName) {
      const record = {
        month: this.exportForm.month,
        sales: this.exportForm.sales,
        agentid: this.exportForm.agentid,
        detailBillType: this.exportForm.detailBillType,
        fileName: fileName,
        downloadTime: new Date().getTime()
      };

      this.downloadHistory.unshift(record);
      
      // 只保留最近20条记录
      if (this.downloadHistory.length > 20) {
        this.downloadHistory = this.downloadHistory.slice(0, 20);
      }

      localStorage.setItem('downloadHistory', JSON.stringify(this.downloadHistory));
    },

    redownload(record) {
      this.exportForm.month = record.month;
      this.exportForm.sales = record.sales;
      this.exportForm.agentid = record.agentid;
      this.exportForm.detailBillType = record.detailBillType || '';
      this.downloadIntegratedExcel();
    },

    deleteHistory(index) {
      this.$confirm('确定删除这条下载记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.downloadHistory.splice(index, 1);
        localStorage.setItem('downloadHistory', JSON.stringify(this.downloadHistory));
        this.$message.success('删除成功');
      }).catch(() => {});
    },

    formatDate(timestamp) {
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
  }
};
</script>

<style scoped>
.integrated-export-container {
  padding: 20px;
}

.export-form {
  max-width: 800px;
}

.history-section {
  margin-top: 30px;
}
</style>
